import { Edit } from '@mui/icons-material';
import { Alert, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { editProductDetail } from '../../../api/products';
import Modal from '../../elements/Modal';
import EditSpecsForm from './EditSpecsForm';

export default function EditProductSpecs({ fetchData, detail, token, setMessage,
  setSnackbarOpen, }) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    setError(null);

    try {
      const payload = {
        ...values,
      };
      const response =  await editProductDetail(payload, detail.id, token);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setMessage('Product details updated successfully');
      fetchData();
      handleClose();
    } catch (error) {
      setError(error.message ||'Failed to edit detail');
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  return (
    <>
      <IconButton size="small" sx={{ p: 2}} onClick={handleClickOpen}>
        <Edit />
      </IconButton>
      <Modal
        open={open}
        modalTitle="Edit product detail"
        handleClose={handleClose}
        width={'sm'}>
        {error && <Alert severity="error">{error}</Alert>}
        <EditSpecsForm onSubmit={handleSubmit} detail={detail} />
      </Modal>
    </>
  );
}
